export default __webpack_public_path__ + "static/media/rain.d66d8c8c.mp3";